<template>
  <div>
    <div class="font-bold p-2">{{ isStagepin ? 'Stage Pin' : 'Icon' }}</div>
    <div class="flex gap-2 p-2 text-gray-300">
      <SMButton v-if="!isStagepin" v-tippy="'Duplicate'" icon="copy" @click="duplicate" />
      <SMButton v-tippy="'Delete'" icon="delete" @click="remove" />
    </div>
    <ul class="space-y-2 p-2">
      <li>
        <SMNumberInput
          v-model="shapeSize"
          v-tippy="'Icon Size'"
          :min="1"
          :max="700"
          :step="1"
          icon="enlarge"
          @change="onShapeSizeValueChange"
        />
      </li>
    </ul>

    <div v-if="isStagepin" class="m-2 text-sm p-2 border rounded bg-white">
      <strong>Note:</strong>
      A stage pin is used to show users an indicator pointing into the direction of the stage as they browse the map
    </div>
  </div>
</template>
<script lang="ts">
import first from 'lodash/first';
import SMButton from '@/components/ui/SMButton.vue';
import SMNumberInput from '@/components/ui/SMNumberInput.vue';
import eventbus from 'tiny-emitter/instance';

export default {
  components: {
    SMButton,
    SMNumberInput,
  },
  props: ['units'],
  data() {
    return {
      shapeSize: 1,
    };
  },
  computed: {
    unit() {
      return first(this.units);
    },
    isStagepin() {
      return this.unit === this.$app.seatmap.stagepin;
    },
  },
  created() {
    this.shapeSize = this.unit.attributes.scale * 100;
  },
  methods: {
    onShapeSizeValueChange(value) {
      this.unit.onResize(value / 100);
      eventbus.emit('selection:delayedHistory', 'Shape size change');
      eventbus.emit('seatmap:updateSelectionBox');
    },
    duplicate() {
      eventbus.emit('selection:clone');
    },
    remove() {
      eventbus.emit('selection:remove');
    },
  },
};
</script>
